/**
 * enum of retailer partner types
 * @readonly
 * @enum
 */
export var RetailerPartnerType;
(function (RetailerPartnerType) {
    RetailerPartnerType["NONE"] = "none";
    RetailerPartnerType["WALMART"] = "walmart";
    RetailerPartnerType["KROGER"] = "kroger";
    RetailerPartnerType["TARGET"] = "target";
    RetailerPartnerType["AMAZON_FRESH"] = "amazonFresh";
    RetailerPartnerType["INSTACART"] = "instacart";
})(RetailerPartnerType || (RetailerPartnerType = {}));
